import { BwsCart } from './BwsCart.js';

customElements.define('bws-cart', BwsCart);
